var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-container", {
    staticClass: "general-structure"
  }, [_c("global-header", {
    style: _vm.$route.meta.headerClass === "none" ? "display:none;" : ""
  }), _vm._v(" "), _c("el-main", {
    staticClass: "main"
  }, [_c("top-bar"), _vm._v(" "), _c("router-view")], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };